<template>
  <v-list-item
    class="mb-1 pa-0 pl-4" :to="{ path: route, params: params }"
    :target="inNewCard ? '_blank' : '_top'"
  >
    <v-list-item-action>
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  export default {
    name: 'NavigationItem',
    props: {
      title: String,
      route: String,
      icon: String,
      params: Object,
      inNewCard: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
